import clsx from "clsx";
const DEFAULT_PERXIS_AUTO_PREFIX_CLS = "perxis-auto";
const DEFAULT_ANT_PREFIX_CLS = "ant";
const classnames = (local, external) => {
  const localClassName = clsx(Array.isArray(local) ? [...local] : [local]);
  const localClasses = localClassName.split(" ");
  let className = localClasses.map((cls) => {
    if (cls.includes("perxis-auto-1_17_2") || cls.includes("ant-5_24_1")) {
      return cls;
    }
    if (cls.includes(DEFAULT_PERXIS_AUTO_PREFIX_CLS)) {
      return cls.replace(DEFAULT_PERXIS_AUTO_PREFIX_CLS, "perxis-auto-1_17_2");
    }
    if (cls.includes(DEFAULT_ANT_PREFIX_CLS)) {
      return cls.replace(DEFAULT_ANT_PREFIX_CLS, "ant-5_24_1");
    }
    return cls;
  }).join(" ");
  if (external) {
    const externalClassName = clsx(Array.isArray(external) ? [...external] : [external]);
    className += ` ${externalClassName}`;
  }
  return className;
};
export {
  classnames as default
};
//# sourceMappingURL=classnames.js.map
